var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrashGrey = function SvgTrashGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#9C9C9C",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 4.983a85 85 0 0 0-8.35-.416q-2.475 0-4.95.25l-1.7.166M7.084 4.142l.183-1.092c.133-.792.233-1.383 1.641-1.383h2.184c1.408 0 1.516.625 1.641 1.391l.184 1.084M15.708 7.617l-.542 8.391c-.091 1.309-.166 2.325-2.491 2.325h-5.35c-2.325 0-2.4-1.016-2.492-2.325l-.542-8.391M8.608 13.75h2.775M7.917 10.417h4.166"
  }))));
};
export { SvgTrashGrey as ReactComponent };
export default __webpack_public_path__ + "a36b5992fd5a35a11aa77778d10da8dd.svg";